export const settingAccommodation = {
    p1: `Informações básicas`,
    p2: `Insira o nome e o logo que os usuários verão ao iniciar o processo de check-in. Se você não tiver um logo, o logo padrão do WACheckin será usado.`,
    p3: `Políticas da acomodação`,
    p4: `Personalize as políticas da sua acomodação. Estas serão as condições que os hóspedes aceitarão ao fazer o check-in.`,
    p5: `ESPANHOL`,
    p6: `INGLÊS`,
    p7: `Mensagem de boas-vindas`,
    p8: `Personalize a mensagem de boas-vindas que seus hóspedes verão após concluir o check-in.`,
    p9: `Chaves dos quartos`,
    p10: `Cadastre e gerencie os quartos equipados com fechaduras inteligentes. Configure os códigos de acesso que serão fornecidos aos hóspedes após o check-in para facilitar a entrada.`,
    p11: `Autoridades competentes`,
    p12: `Configure a conexão com as autoridades locais para o envio automático dos relatórios de viajantes. Insira o nome de usuário e a senha correspondentes à plataforma de cada autoridade competente.`,
    p13: `Guarda Civil`,
    p14: `Polícia Nacional`,
    p15: `Ertzaintza`,
    p16: `Mossos`,
    p17: `dados de acesso`,
    p18: `A entidade é obrigatória`,
    p19: `O nome de usuário é obrigatório`,
    p20: `A senha é obrigatória`,
    p21: `Erro ao tentar validar os dados`,
    p22: `A entidade é obrigatória`,
    p23: `O nome de usuário é obrigatório`,
    p24: `A senha é obrigatória`,
    p25: `Dados atualizados com sucesso`,
    p26: `Erro ao inserir os dados da polícia de imigração`,
    p27: `Baixe o QR code da sua acomodação para check-ins rápidos e obtenha o link para enviar diretamente aos hóspedes.`,
    p28: `Editar código de segurança da acomodação`,
    p29: `Verificamos a identidade dos hóspedes comparando a foto do documento ou passaporte com uma selfie em tempo real.`,
    p30: `Ao ativar esta opção, os hóspedes precisarão verificar a identidade durante o processo de check-in. Se a validação não for concluída com sucesso, eles não poderão prosseguir com o check-in.`,
    p31: `Erro ao ativar a verificação de identidade`,
    p32: `Configurações de pagamento`,
    p33: `Cobre os hóspedes durante o processo de check-in, permitindo que paguem por serviços adicionais e taxas aplicáveis.`,
    p34: `Código de segurança da acomodação`,
    p35: `Acomodação`,
    p36: `Ative esta opção para enviar automaticamente uma mensagem no WhatsApp no dia do check-out, pedindo que os hóspedes avaliem a experiência na acomodação de 1 a 5.`,
    p37: `Insira a URL do site de avaliações que você deseja configurar para que seus hóspedes deixem suas opiniões, seja no Google ou em outro site de avaliações que você use. Isso ajuda a melhorar a visibilidade e a reputação da acomodação.`,
    p38: `Insira a URL do site de avaliações (ex.: Google, TripAdvisor)`,
    p39: `Gerencie sua acomodação`,
    p40: `Informações básicas`,
    p41: `Políticas da acomodação`,
    p42: `Mensagem de boas-vindas`,
    p43: `QR da acomodação`,
    p44: `Pagamentos dos hóspedes`,
    p45: `Enviar logo da acomodação`,
    p46: `Você pode enviar ou arrastar uma imagem para a caixa`,
    p47: `Design`,
    p48: `Políticas`,
    p49: `Boas-vindas`,
    p50: `Região`,
    p51: `Espanhol`,
    p52: `Inglês`,
    p53: `Árabe`,
    p54:``,
    p55:``,
    p56:``,
    p57:``,
    p58:``,
    p59:``,
    p60:``,
    p61:``,
    p62:``,
    p63:``,
    p64:``,
    p65:``,
    p66:``,
    p67:``,
    p68:``,
    p69:``,
    p70:``,
};
